/**
 * Centralize Custom Events
 */

if (typeof CUSTOM_EVENTS === "undefined") {
  CUSTOM_EVENTS = {
    CollectionFilterTags_Changed: "CollectionFilterTags_Changed",
    CollectionFilterTags_Changed_Constructor:
      "CollectionFilterTags_Changed_Constructor",
    CollectionFilterSubCollections_Changed:
      "CollectionFilterSubCollections_Changed",
  };
}

class CollectionFilterSubCollections extends HTMLElement {
  /**
   * @type {HTMLElement}
   */
  subCollectionListContainer;

  constructor() {
    super();
    this.currentScrollLeft = 0;
    this.btnNext = null;
    this.btnPrev = null;

    this.initElement();
  }

  initElement() {
    try {
      this.eventType = CUSTOM_EVENTS.CollectionFilterSubCollections_Changed;
      this.collectionUrl = this.dataset.collectionUrl;
      this.subCollectionSeparator = this.dataset.subCollectionSeparator;
      this.parentCollectionImage = this.dataset.parentCollectionImage || "";
      this.subCollections = [];

      this.parentCollectionId = this.dataset.parentCollectionId;
      this.parentCollectionUrl = this.dataset.parentCollectionUrl;
      this.parentCollectionTitle = this.dataset.parentCollectionTitle;
      this.currentCollectionId = this.dataset.collectionId;
      this.parentCollectionConstructorId =
        this.dataset.parentCollectionConstructorId;

      if (this.dataset.subCollectionNames && this.dataset.subCollectionIds) {
        const subCollectionNames =
          this.dataset.subCollectionNames
            .split(this.subCollectionSeparator)
            .filter((el) => el) || [];
        const subCollectionIds =
          this.dataset.subCollectionIds
            .split(this.subCollectionSeparator)
            .filter((el) => el) || [];
        const constructorCollectionIds =
          this.dataset.constructorCollectionIds
            .split(this.subCollectionSeparator)
            .filter((el) => el) || [];
        const subCollectionUrls =
          this.dataset.subCollectionUrls
            .split(this.subCollectionSeparator)
            .filter((el) => el) || [];
        const subCollectionTitles =
          this.dataset.subCollectionTitles
            .split(this.subCollectionSeparator)
            .filter((el) => el) || [];
        const subCollectionImages =
          this.dataset.subCollectionImages
            ?.split(this.subCollectionSeparator)
            .slice(1) || [];

        subCollectionIds.forEach((subCollectionId, index) => {
          if (!subCollectionId) return;

          this.subCollections.push({
            name: subCollectionNames[index],
            active: subCollectionId === this.currentCollectionId,
            id: subCollectionId,
            url: subCollectionUrls[index],
            title: subCollectionTitles[index],
            constructorCollectionId: constructorCollectionIds[index],
            image: subCollectionImages[index] || "",
          });
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  connectedCallback() {
    this.render();
    this.setupEvents();
  }

  validateParams() {
    if (
      !this.subCollections.length ||
      !this.collectionUrl ||
      !this.subCollectionSeparator
    )
      return false;
    return true;
  }

  render() {
    const skel = this.closest('.sc-circle-wrapper')?.querySelector('.sc-circle-skel');
    if (skel) skel.style.display = 'none';

    const showAllActive = this.currentCollectionId === this.parentCollectionId;

    const renderSubCollectionBeans = this.subCollections
      .filter((sub) => sub.image)
      .map(
        (sub) => /* HTML */`
          <li
            class="sub-collection ${sub.active ? "active" : ""}"
            data-sub-collection-id="${sub.id}"
            data-sub-collection-constructor-id="${sub.constructorCollectionId}"
            data-sub-collection-url="${sub.url}"
            data-sub-collection-title="${sub.title}"
            is-show-all="false"
          >
            <a class="sub-collection-card" href="${sub.url}">
              <div class="sub-collection-image">
                ${sub.image
                  ? `<img src="${sub.image}" alt="${sub.name}" loading="lazy" />`
                  : ""}
              </div>
              <span class="sub-collection-label">${sub.name}</span>
            </a>
          </li>`,
      )
      .join("");

    const renderShowAllBean = () => `
      <li
        class="sub-collection show-all-item ${showAllActive ? "active" : ""}"
        data-sub-collection-id="${this.parentCollectionId}"
        data-sub-collection-constructor-id="${this.parentCollectionConstructorId}"
        data-sub-collection-url="${this.parentCollectionUrl}"
        data-sub-collection-title="${this.parentCollectionTitle}"
        is-show-all="true"
      >
        <a class="sub-collection-card" href="${this.parentCollectionUrl}">
          <div class="sub-collection-image">
            ${this.parentCollectionImage
              ? `<img src="${this.parentCollectionImage}" alt="${this.parentCollectionTitle}" loading="lazy" />`
              : ""}
          </div>
          <span class="sub-collection-label">Show All</span>
        </a>
      </li>`;

    this.innerHTML = `
      <div class="sub-collection-container">
        <ul class="sub-collection-list sub-collection-list-persistent">
          ${renderShowAllBean()}
        </ul>
        <div class="sub-collection-scroll-wrap">
          <button id="btn-prev" aria-label="Previous Sub Collection">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#121212bf"><path d="M561-240 320-481l241-241 43 43-198 198 198 198-43 43Z"/></svg>
          </button>
          <ul class="sub-collection-list hide-scroll-bar sub-collection-list-main">
            ${renderSubCollectionBeans}
          </ul>
          <button id="btn-next" aria-label="Next Sub Collection">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#121212bf"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>
          </button>
        </div>
      </div>
    `;
  }

  setupEvents() {
    this.btnNext = this.querySelector("#btn-next");
    this.btnPrev = this.querySelector("#btn-prev");
    this.subCollectionListContainer = this.querySelector(
      ".sub-collection-list-main",
    );
    this.subCollectionEls = this.querySelectorAll(".sub-collection");

    if (this.btnNext) {
      this.btnNext.addEventListener("click", () => {
        this.setScrollLeft(this.getScrollStep());
      });
    }

    if (this.btnPrev) {
      this.btnPrev.addEventListener("click", () => {
        this.setScrollLeft(-this.getScrollStep());
      });
    }

    this.subCollectionListContainer.addEventListener("scroll", () => {
      this.currentScrollLeft = this.subCollectionListContainer.scrollLeft;
      this.updateButtonStates();
    });

    this.subCollectionEls.forEach((el) => {
      el.addEventListener("click", () => {
        const isShowAll = el.getAttribute("is-show-all") === "true";
        if (isShowAll) return;

        this.subCollectionEls.forEach((e) => e.classList.remove("active"));
        el.classList.add("active");

        window.dispatchEvent(
          new CustomEvent(this.eventType, {
            detail: {
              subCollectionId: el.dataset.subCollectionId,
              subCollectionConstructorId:
                el.dataset.subCollectionConstructorId,
            },
          }),
        );
      });
    });

    window.addEventListener("resize", () => {
      this.updateButtonStates();
    });

    window.addEventListener("popstate", () => {
      if (document.querySelector("collection-filter-sub-collections-new")) {
        window.location.reload();
      }
    });

    this._resizeObserver = new ResizeObserver(() => {
      if (this._resizeRAF) return;

      this._resizeRAF = requestAnimationFrame(() => {
        this._resizeRAF = null;

        const container = this.subCollectionListContainer;
        if (!container) return;
        this.scrollToActiveItem();
        this.currentScrollLeft = container.scrollLeft || 0;
        this.updateButtonStates();
      });
    });

    this._resizeObserver.observe(this.subCollectionListContainer);

    this.btnPrev.setAttribute("aria-hidden", "true");
    this.btnPrev.setAttribute("tabindex", "-1");
    this.btnNext.setAttribute("aria-hidden", "true");
    this.btnNext.setAttribute("tabindex", "-1");

    this.scrollToActiveItem();
  }

  getScrollStep() {
    const firstItem = Array.from(this.subCollectionEls).find(
      (el) => !el.hasAttribute("hidden"),
    );
    if (!firstItem) return 0;

    const style = window.getComputedStyle(this.subCollectionListContainer);
    const gap = parseInt(style.columnGap || style.gap || 0, 10);

    return firstItem.offsetWidth + gap;
  }

  /**
   * @param {number} value
   */
  setScrollLeft(value) {
    if (isNaN(value)) {
      value = 0;
    }

    this.currentScrollLeft += value;

    if (this.currentScrollLeft < 0) {
      this.currentScrollLeft = 0;
    }

    if (
      this.currentScrollLeft >
      this.subCollectionListContainer.scrollWidth -
        this.subCollectionListContainer.clientWidth
    ) {
      this.currentScrollLeft =
        this.subCollectionListContainer.scrollWidth -
        this.subCollectionListContainer.clientWidth;
    }
    this.subCollectionListContainer.scrollTo({
      left: this.currentScrollLeft,
      behavior: "smooth",
    });
    this.updateButtonStates();
  }

  updateButtonStates() {
    const container = this.subCollectionListContainer;
    if (!container) return;

    const maxScroll = container.scrollWidth - container.clientWidth;

    if (this.currentScrollLeft === 0 && maxScroll > 0) {
      this.btnPrev.classList.add("btn-hidden");
      this.btnNext.classList.remove("btn-hidden");
      return;
    }

    if (maxScroll <= 0) {
      this.btnPrev.classList.add("btn-hidden");
      this.btnNext.classList.add("btn-hidden");
      return;
    }

    if (this.currentScrollLeft <= 0) {
      this.btnPrev.classList.add("btn-hidden");
      this.btnNext.classList.remove("btn-hidden");
      return;
    }

    if (this.currentScrollLeft >= maxScroll - 1) {
      this.btnNext.classList.add("btn-hidden");
      this.btnPrev.classList.remove("btn-hidden");
      return;
    }

    this.btnPrev.classList.remove("btn-hidden");
    this.btnNext.classList.remove("btn-hidden");
  }

  scrollToActiveItem() {
    if (!this.subCollectionListContainer) return;

    requestAnimationFrame(() => {
      const container = this.subCollectionListContainer;
      const activeEl = container.querySelector(".sub-collection.active:not(.show-all-item)");

      if (activeEl) {
        const containerRect = container.getBoundingClientRect();
        const activeRect = activeEl.getBoundingClientRect();

        const isOutOfViewLeft = activeRect.left < containerRect.left;
        const isOutOfViewRight = activeRect.right > containerRect.right;

        if (isOutOfViewLeft || isOutOfViewRight) {
          let targetScrollLeft =
            activeEl.offsetLeft -
            container.clientWidth / 2 +
            activeEl.clientWidth / 2;

          if (targetScrollLeft < 0) targetScrollLeft = 0;

          const maxScroll = container.scrollWidth - container.clientWidth;
          if (targetScrollLeft > maxScroll) targetScrollLeft = maxScroll;

          this.currentScrollLeft = targetScrollLeft;

          try {
            container.scrollTo({
              left: this.currentScrollLeft,
              behavior: "smooth",
            });
          } catch {
            container.scrollLeft = this.currentScrollLeft;
          }
        }
      }

      this.currentScrollLeft = container.scrollLeft || 0;
      this.updateButtonStates();
    });
  }

}

customElements.define(
  "collection-filter-sub-collections-new",
  CollectionFilterSubCollections,
);
